import styles from './RelayStatusMini.module.scss'
// import useRelayStatus from '../../../../features/Jouly/hooks/core/useRelayStatus'

interface Props {
  deviceId?: string
}

export default function RelayStatusMiniPresenter(_props: Props) {
  // Mock désactivé : on affiche "NA" en attendant la vraie source de données.
  // Pour réactiver, restaurer le bloc ci-dessous et retirer le return courant.
  return (
    <span className={styles.unknown} title="Statut relais non disponible">NA</span>
  )

  /*
  const { relayStatusQuery } = useRelayStatus(_props.deviceId)

  if (relayStatusQuery.isLoading) {
    return <span className={styles.loading}>...</span>
  }

  if (relayStatusQuery.isError || !relayStatusQuery.data) {
    return <span className={styles.unknown} title="Statut relais inconnu">—</span>
  }

  const relayOn = relayStatusQuery.data.relay_on

  return (
    <div
      className={styles.container}
      title={`Relais ${relayOn ? 'fermé (ON)' : 'ouvert (OFF)'}`}
    >
      <span className={relayOn ? styles.on : styles.off}>
        {relayOn ? '🟢 ON' : '🔴 OFF'}
      </span>
    </div>
  )
  */
}
